import React from "react";
import styles from './apploader.module.scss'
const AppLoader = () =>{
    return (
        <div className={styles.appLoader}>
            <div className={styles.loaderSpin}>
                <span className={[styles.catalystDot, styles.dotSpin].join(" ")}>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                </span>
            </div>
        </div>
    )
}

export default AppLoader;